import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Shippment } from '../../models/shippment/shippment-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()

export class ShippmentService {
  private service = "api/ShippingMethod"; //Controller Name

  constructor(private http: Http, private readonly router: Router,
    private cookieService: CookieService) { }
  
  GetShippingMethods() {
    return this.http.get(`${this.service}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetActiveShippingMethods() {
    return this.http.get(`${this.service}/GetActiveShippingMethods`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetShippingMethodId(id: string) {
    return this.http.get(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <Shippment>response.json())
      .catch(this.errorHandler)
  }

  //ToggleShippingMethod(id: string) {
  //  return this.http.delete(`${this.service}/` + id)
  //    .subscribe(result => {
  //    });
  //}
  deleteShippment(id: string) {
    return this.http.get(`${this.service}/DeleteShippment?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddShippment(model: Shippment) {
    return this.http
      .post(`${this.service}`, model, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddShippmentLogo(formData: any, userId: number): void {
    this.http
      .post(`${this.service}/SaveShippingMethodLogo?userId=` + userId, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        setTimeout(() => {
          this.router.navigate(["/shipping-methods"]);
        }, 1000);

      });
  }
  getShippmentById(shippmentId: string) {
    return this.http.get(`${this.service}/GetShippmentById?id=` + shippmentId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  updateShippment(model: Shippment) {
    return this.http.post(`${this.service}/UpdateShippment`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  } 

  ToggleShippingMethod(id: number) {
    return this.http
      .post(`${this.service}/` + id, null, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shippment/shippment-setting.ts